import type { UpdateCustomerChildrenPayload } from '@weft/api-definition';
import type { UpdateCustomerChildrenResponse } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUpdateCustomerChildren(customerId: string,
  options?: UseMutationOptions<UpdateCustomerChildrenResponse, unknown, UpdateCustomerChildrenPayload>) {
  const queryClient = useQueryClient();

  return useMutation((updateCustomerChildrenRequest) => {
    const api = getPrivateApi();

    return api.updateCustomerChildren({ customerId, updateCustomerChildrenRequest });
  },
  { onSuccess: async () => queryClient.invalidateQueries(['customer']), ...options });
}